"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventEnums_1 = require("../eventTypes/EventEnums");
var utils_1 = require("../utils");
/* eslint-disable no-use-before-define */
exports.default = (function (_a) {
    var _b = _a === void 0 ? {} : _a, getEventContext = _b.getEventContext;
    if (typeof getEventContext !== 'function') {
        throw new Error('getEventContext is required in EventStruct');
    }
    /**
     * @param {string} type - is required
     * @param {string} eventVersion - is required
     * @param {object} data - is required
     */
    var createEventObject = function (_a) {
        var _b = _a === void 0 ? {} : _a, type = _b.type, eventVersion = _b.eventVersion, occurredAt = _b.occurredAt, tenantId = _b.tenantId, clientId = _b.clientId, clientVersion = _b.clientVersion, data = _b.data;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var eventContext = getEventContext();
        return {
            type: type,
            // eventId: undefined,
            eventVersion: eventVersion,
            occurredAt: occurredAt || utils_1.getOccurredAt(),
            tenantId: tenantId || eventContext.tenantId,
            clientId: clientId || eventContext.clientId,
            clientVersion: clientVersion || eventContext.clientVersion,
            data: data,
        };
    };
    /**
     * all params are optional
     */
    var createEventClientDetails = function (_a) {
        var _b = _a === void 0 ? {} : _a, sessionId = _b.sessionId, productArea = _b.productArea, deviceType = _b.deviceType, browser = _b.browser, browserVersion = _b.browserVersion, operatingSystem = _b.operatingSystem, operatingSystemVersion = _b.operatingSystemVersion, locale = _b.locale;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var eventContext = getEventContext();
        return {
            sessionId: sessionId || eventContext.sessionId,
            productArea: productArea,
            deviceType: deviceType || eventContext.deviceType || EventEnums_1.EVENT_DEVICE_TYPE.unknown,
            browser: browser || eventContext.browser || EventEnums_1.EVENT_BROWSER.unknown,
            browserVersion: browserVersion || eventContext.browserVersion,
            operatingSystem: operatingSystem || eventContext.operatingSystem || EventEnums_1.EVENT_OPERATING_SYSTEM.unknown,
            operatingSystemVersion: operatingSystemVersion || eventContext.operatingSystemVersion,
            locale: locale || eventContext.locale || EventEnums_1.EVENT_LOCALE_TYPE.unknown,
        };
    };
    /**
     * all params are optional
     */
    var createEventIntegratorContext = function (integratorContextParams) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var eventContext = getEventContext();
        var integratorContext = eventContext.integratorContext;
        if (!integratorContextParams && !integratorContext)
            return undefined;
        var _a = integratorContextParams || {}, systemType = _a.systemType, systemId = _a.systemId, contextType = _a.contextType, contextName = _a.contextName, contextId = _a.contextId;
        var contextObject = {
            systemType: systemType || integratorContext.systemType,
            systemId: systemId || integratorContext.systemId,
            contextType: contextType || integratorContext.contextType,
            contextName: contextName || integratorContext.contextName,
            contextId: contextId || integratorContext.contextId,
        };
        return !contextObject.contextId && !integratorContext.contextName && !integratorContext.contextType
            ? null
            : contextObject;
    };
    return {
        createEventObject: createEventObject,
        createEventClientDetails: createEventClientDetails,
        createEventIntegratorContext: createEventIntegratorContext,
    };
});
//# sourceMappingURL=EventStruct.js.map